import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { PageHero, Loader } from "../components/ui-bits";
import { Reveal } from "../components/Reveal";
import { MediaImage } from "../components/MediaImage";

const BG = "https://images.unsplash.com/photo-1499750310107-5fef28a66643?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000";

export default function Blog() {
  const [posts, setPosts] = useState(null);
  useEffect(() => {
    api.get("/blog").then((r) => setPosts(r.data)).catch(() => setPosts([]));
  }, []);

  if (posts === null) return <Loader label="Loading blog" />;

  const [feature, ...rest] = posts;

  return (
    <div data-testid="blog-page">
      <PageHero
        eyebrow="Insights & Stories"
        title="The SRAM & MRAM Blog"
        subtitle="Perspectives on technology, markets and the ventures shaping our global ecosystem."
        bg={BG}
      />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {feature && (
          <Reveal>
            <Link to={`/blog/${feature.slug}`} data-testid={`blog-feature-${feature.slug}`} className="card-vertical rounded-3xl overflow-hidden grid lg:grid-cols-2 group mb-12">
              <div className="h-64 lg:h-auto overflow-hidden">
                <MediaImage src={feature.image_url} alt={feature.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="p-8 lg:p-12 flex flex-col justify-center">
                <p className="font-mono text-xs text-emerald-400 mb-3">Featured · {feature.date}</p>
                <h2 className="text-2xl lg:text-3xl font-display font-bold text-white group-hover:text-emerald-400 transition-colors">{feature.title}</h2>
                <p className="text-slate-400 mt-4 line-clamp-3">{feature.excerpt}</p>
                <span className="text-emerald-400 font-mono text-sm mt-6">Read article →</span>
              </div>
            </Link>
          </Reveal>
        )}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {rest.map((p, i) => (
            <Reveal key={p.id} delay={(i % 3) * 0.06}>
              <Link to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`} className="card-vertical rounded-2xl overflow-hidden group flex flex-col h-full">
                <div className="h-48 overflow-hidden">
                  <MediaImage src={p.image_url} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                </div>
                <div className="p-6 flex flex-col flex-1">
                  <p className="font-mono text-xs text-emerald-400 mb-2">{p.date}</p>
                  <h3 className="font-display font-semibold text-white line-clamp-2 group-hover:text-emerald-400 transition-colors">{p.title}</h3>
                  <p className="text-sm text-slate-400 mt-2 line-clamp-3 flex-1">{p.excerpt}</p>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
